/**
 * Date Range Picker Utilities
 * Shared helper functions for date manipulation and state management
 */
(function(window){
  'use strict';

  window.LiteDRPUtils = {
    formatYMD: (d) => { if(!d || isNaN(d.getTime())) return ''; const yyyy=d.getFullYear(); const mm=String(d.getMonth()+1).padStart(2,'0'); const dd=String(d.getDate()).padStart(2,'0'); return `${yyyy}-${mm}-${dd}`; },
    
    parseYMD: (s) => { if(!s) return null; const d=new Date(s); return isNaN(d.getTime())?null:d; },
    
    isMobile: () => { try { return window.matchMedia('(max-width: 640px)').matches; } catch(_) { return false; } },
    
    ensureLitepickerLoaded: (callback) => { try { callback(); } catch(_) {} },
    
    roundDownDecade: (y) => Math.floor(y/10)*10,
    
    roundUpDecade: (y) => Math.floor(y/10)*10 + 9,
    
    currentFromDate: () => { try { const f = document.querySelector('.filter-date-from')?.value; if (!f) return null; const d = new Date(f); return isNaN(d.getTime()) ? null : d; } catch(_) { return null; } },
    
    currentToDate: () => { try { const t = document.querySelector('.filter-date-to')?.value; if (!t) return null; const d = new Date(t); return isNaN(d.getTime()) ? null : d; } catch(_) { return null; } },
    
    persistSel: (sel) => { try { localStorage.setItem('lite_drp_sel', JSON.stringify(sel)); } catch(_){ } },
    
    loadSel: () => { try { const j=localStorage.getItem('lite_drp_sel'); return j ? Object.assign({ from:{}, to:{} }, JSON.parse(j)) : { from:{}, to:{} }; } catch(_){ return { from:{}, to:{} }; } },
    
    getConstraints: (which, minDate, maxDate) => {
      const baseMin = minDate || null;
      const baseMax = maxDate || null;
      const fromDate = window.LiteDRPUtils.currentFromDate();
      const toDate = window.LiteDRPUtils.currentToDate();
      let min = baseMin, max = baseMax;
      if (which === 'from') { if (toDate) max = toDate; }
      else { if (fromDate) min = fromDate; }
      return { min: min, max: max };
    },
    
    getGlobalMinYear: () => {
      try {
        const meta = window.__idbMetaCache || (window.filesCacheManager && typeof window.filesCacheManager.getMeta==='function' ? window.filesCacheManager.getMeta() : null);
        if (meta && meta.date_min) {
          const d = new Date(meta.date_min);
          return d.getFullYear();
        }
      } catch(_){}
      return 1950; // fallback
    }
  };
})(window);

